module.exports = __webpack_public_path__ + "img/continous.661d8308.png";